import Vue from 'vue';

// https://www.digitalocean.com/community/tutorials/vuejs-global-event-bus
export const GlobalEvents = new Vue();
